<template>
  <div class="positive-negative-bar-chart-node">
    <div class="positive-negative-bar-chart-info">
      <ChartHeader
        :value="value"
        :display-chart="displayChart"
        @set-display-chart="setDisplayChart"
      />
      <span class="positive-negative-bar-chart-instructions" v-show="displayChart">
        Double click to zoom
        <span>Drag to select</span>
        <button @click="resetSelection">Reset selection</button>
      </span>
    </div>

    <div class="positive-negative-bar-chart-container" v-show="displayChart">
      <svg ref="chart" class="pigeondoc-chart positive-negative-bar-chart"></svg>
    </div>

    <PositiveNegativeBarChartTable
      :value="value"
      ref="alt-table"
      @reset-selection="resetSelection"
      @selection-changed="selectionChanged"
      v-show="!displayChart"
    />
  </div>
</template>

<script>
import ChartHeader from '../ChartHeader/ChartHeader.vue';
import PositiveNegativeBarChartTable from './PositiveNegativeBarChartTable.vue';

import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';
import Chart from './Chart';

export default {
  name: 'PositiveNegativeBarChart',
  props: {
    value: PigeonDocNodeModel,
  },
  components: {
    ChartHeader,
    PositiveNegativeBarChartTable,
  },
  data() {
    return {
      chart: null,
      displayChart: false,
    };
  },
  mounted() {
    this.createChart();
  },
  created() {
    if (this.value.meta.isSentimentChart && this.value.meta.isSentimentMode) {
      this.displayChart = true;
    }
    if (!this.value.meta.isSentimentChart) {
      this.displayChart = true;
    }
  },
  watch: {
    value() {
      this.renderChart();
    },
    displayChart(val) {
      if (!val || this.chart == null) return;
      this.renderChart();
    },
  },
  methods: {
    createChart() {
      this.chart = new Chart(this.$refs['chart'], this.value.content.data, this.value.meta);
      this.chart.createChart();
      this.chart.addChangeHandler(this.selectionChanged);
    },
    renderChart() {
      this.chart.empty();
      this.$nextTick(
        function () {
          this.createChart();
        }.bind(this),
      );
    },
    selectionChanged(selection) {
      this.$emit('change', selection);
    },
    resetSelection() {
      this.chart.resetSelection();
    },
    setDisplayChart(value) {
      this.displayChart = value;
    },
  },
};
</script>

<style>
.positive-negative-bar-chart {
  cursor: crosshair;
}

.positive-negative-bar-chart-node {
  margin: 4rem 0;
}

.positive-negative-bar-chart-info {
  display: grid;
  grid-template-rows: 1fr 1fr;
}

.positive-negative-bar-chart-info > .chart-header__wrapper {
  margin: 0;
}

.positive-negative-bar-chart-instructions {
  font-size: 0.8rem;
  display: flex;
  flex-direction: column;
  border: 1px solid #888;
  padding: 0.5rem;
  justify-self: right;
}

.positive-negative-bar-chart-container {
  overflow: auto;
}

.positive-negative-bar-chart-node svg {
  min-width: 100%;
}
</style>
